export default "__VITE_ASSET__BCAlPYRY__"